import script from "./TextareaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextareaInput.vue?vue&type=script&setup=true&lang=js"

import "./TextareaInput.vue?vue&type=style&index=0&id=2437d494&lang=scss"

const __exports__ = script;

export default __exports__